import { ArticleDataType, ResponseArticleDataType } from './type';

export const transformArticle = (
  article: ResponseArticleDataType,
): ArticleDataType => {
  if (!article) return;

  return {
    id: article.id,
    slug: article?.attributes?.slug ?? '',
    title: article?.attributes?.title ?? '',
    content: article?.attributes?.content ?? '',
    createAt: article?.attributes?.createdAt ?? '',
    publishedAt: article?.attributes?.publishedAt ?? '',
    locale: article?.attributes?.locale ?? '',
    description: article?.attributes?.description ?? '',
    newsFromPlatform: article?.attributes?.newsFromPlatform ?? '',
    newsOutBoundLink: article?.attributes?.newsOutBoundLink ?? '',
    imgUrl: article?.attributes?.image?.data?.attributes?.url ?? '',
    // categories: article.attributes?.categories?.data?.map(
    //   (i) => i.attributes.name,
    // ),
  };
};

export default transformArticle;
